import { useState } from "react";
import { PHONE, PHONE_TEL, WA } from "../data";

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className="topbar" data-testid="urgency-bar">
        <span className="dot"></span>Atendimento agora • Resposta rápida em todo o litoral paulista •{" "}
        <a href={`tel:${PHONE_TEL}`} data-testid="topbar-phone-link">{PHONE}</a>
      </div>
      <header className="header">
        <div className="container header-in">
          <a className="brand" href="/" data-testid="header-logo-link" aria-label="Desentope Maresias — Home">
            <img src="/img/logo.webp" alt="Logo Desentope Maresias 24 Horas — desentupidora no litoral de São Paulo" width="158" height="52" />
          </a>
          <button className="menu-toggle" data-testid="mobile-menu-toggle" aria-label="Abrir menu" onClick={() => setOpen(!open)}>
            <span></span><span></span><span></span>
          </button>
          <nav className={`nav${open ? " open" : ""}`} aria-label="Navegação principal">
            <a href="/" data-testid="nav-home">Home</a>
            <a href="/servicos/" data-testid="nav-servicos">Serviços</a>
            <a href="/praias/" data-testid="nav-praias">Praias</a>
            <a href="/sobre.html" data-testid="nav-sobre">Sobre</a>
            <a href="/blog/" data-testid="nav-blog">Blog</a>
            <a href="/contato.html" data-testid="nav-contato">Contato</a>
            <a className="btn-wa-top" href={WA} rel="noopener noreferrer" target="_blank" data-testid="nav-whatsapp-btn">WhatsApp 24h</a>
          </nav>
        </div>
      </header>
    </>
  );
};
